<template>
<svg
   width="16"
   height="16"
   fill="currentColor"
   class="bi bi-square-fill-plus"
  viewBox="0 0 16 16"
>
  <path
     style="stroke-width:0.87500006"
     d="M 1.75 0 A 1.75 1.75 0 0 0 0 1.75 L 0 12.25 A 1.75 1.75 0 0 0 1.75 14 L 5.8125 14 A 6 6 0 0 1 5 11 A 6 6 0 0 1 11 5 A 6 6 0 0 1 14 5.8105469 L 14 1.75 A 1.75 1.75 0 0 0 12.25 0 L 1.75 0 z "
     id="path62" />
     <path
       inkscape:connector-curvature="0"
       style="display:inline;fill-rule:evenodd;stroke-width:1.60015988"
       d="m 11,6.9999998 a 0.80016,0.79999983 0 0 1 0.800161,0.7999999 v 2.4000013 h 2.400479 a 0.80016008,0.7999999 0 0 1 0,1.599999 h -2.400479 v 2.4 a 0.80016053,0.80000032 0 0 1 -1.600321,0 V 11.8 H 7.79936 a 0.80016008,0.7999999 0 0 1 0,-1.599999 h 2.40048 V 7.7999997 A 0.80016,0.79999983 0 0 1 11,6.9999998 Z"
       id="path1191-3" />
  <!-- <path
    inkscape:connector-curvature="0"
    style="display:inline;fill-rule:evenodd;stroke-width:2.00006175"
    d="m 10.999553,6 a 1,1.0000616 0 0 1 1,1.0000617 v 3.0001853 h 3 a 1,1.0000616 0 0 1 0,2.000123 h -3 v 3.000185 a 1.0000002,1.0000618 0 0 1 -2.0000002,0 V 12.00037 h -3 a 1,1.0000616 0 0 1 0,-2.000123 h 3 V 7.0000617 A 1,1.0000616 0 0 1 10.999553,6 Z"
    id="path1191-3" /> -->

<!-- STANDARD SMALL ICON
  <path
     style="stroke-width:0.87500006"
     d="M 1.75 0 A 1.75 1.75 0 0 0 0 1.75 L 0 12.25 A 1.75 1.75 0 0 0 1.75 14 L 8.2636719 14 A 4.5 4.5 0 0 1 8 12.5 A 4.5 4.5 0 0 1 12.5 8 A 4.5 4.5 0 0 1 14 8.2636719 L 14 1.75 A 1.75 1.75 0 0 0 12.25 0 L 1.75 0 z "
     id="path62" />
  <path
     inkscape:connector-curvature="0"
     style="fill-rule:evenodd"
     d="M 12.5,10 A 0.5,0.5 0 0 1 13,10.5 V 12 h 1.5 a 0.5,0.5 0 0 1 0,1 H 13 v 1.5 a 0.5,0.5 0 0 1 -1,0 V 13 h -1.5 a 0.5,0.5 0 0 1 0,-1 H 12 V 10.5 A 0.5,0.5 0 0 1 12.5,10 Z"
     id="path1191" />
-->
</svg>
</template>

<script>
// https://icons.getbootstrap.com/icons/square-fill/ +
// https://icons.getbootstrap.com/icons/send-plus-fill/
// Via: square-crop.svg to trim a circle out off the square

export default {
  name: "SquareFillPlus"
}
</script>

<style>

</style>